module.exports = __webpack_public_path__ + "img/djq.9a13f7fb.png";